export default __webpack_public_path__ + "static/guide-00d235dbeeeb3588daff3caa9d0ad999.png";